/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { WorkflowTemplatesControllerUpdateMutationRequest, WorkflowTemplatesControllerUpdateMutationResponse, WorkflowTemplatesControllerUpdatePathParams, WorkflowTemplatesControllerUpdate400, WorkflowTemplatesControllerUpdate401, WorkflowTemplatesControllerUpdate403, WorkflowTemplatesControllerUpdate404 } from "../../models/workflowsController/WorkflowTemplatesControllerUpdate";

function getWorkflowTemplatesControllerUpdateUrl(id: WorkflowTemplatesControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/workflow-templates/${id}` as const }  
  return res
}

/**
 * @summary Update a workflow template
 * {@link /api/v1/workflow-templates/:id}
 */
export async function workflowTemplatesControllerUpdate(id: WorkflowTemplatesControllerUpdatePathParams["id"], data?: WorkflowTemplatesControllerUpdateMutationRequest, config: Partial<RequestConfig<WorkflowTemplatesControllerUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<WorkflowTemplatesControllerUpdateMutationResponse, ResponseErrorConfig<WorkflowTemplatesControllerUpdate400 | WorkflowTemplatesControllerUpdate401 | WorkflowTemplatesControllerUpdate403 | WorkflowTemplatesControllerUpdate404>, WorkflowTemplatesControllerUpdateMutationRequest>({ method : "PATCH", url : getWorkflowTemplatesControllerUpdateUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}